@if (hasContent()) {
  <ul [class.vertical]="displayVertically()">
    @for (label of labels(); track label) {
      <li>
        @switch (label.selector) {
          @case ('product-bundle-valid-to') {
            <ui-product-bundle-valid-to-label
              [bundleType]="product().bundleType!"
              [validTo]="product().prices?.validTo"
            ></ui-product-bundle-valid-to-label>
          }
          @case ('product-bundle-max-order-count') {
            @if (product().bundle?.maxOrderCount; as maxOrderCount) {
              <ui-product-bundle-max-order-count-label [maxOrderCount]="maxOrderCount"></ui-product-bundle-max-order-count-label>
            }
          }
          @case ('product-price-best') {
            <ng-container *ngTemplateOutlet="bestPriceLabel"></ng-container>
          }
          @case ('product-price-discount') {
            <ng-container *ngTemplateOutlet="discountPriceLabel"></ng-container>
          }
          @case ('product-price-promotion') {
            <ng-container *ngTemplateOutlet="promotionPriceLabel"></ng-container>
          }
          @default {
            <ng-container *ngTemplateOutlet="label.type === 'text' ? tplLabelText : tplLabelIcon; context: { label }"></ng-container>
          }
        }
      </li>
    }
  </ul>
}

<ng-template #tplLabelText let-label="label">
  <span [ngClass]="label.selector" [title]="label.title" class="text-label">
    {{ label.name }}
  </span>
</ng-template>

<ng-template #tplLabelIcon let-label="label">
  @if (label.type === 'icon') {
    <ui-icon
      [class.icon-big]="iconLabelsBig()"
      [faName]="label.name"
      [faStyle]="label.style"
      [ngClass]="label.selector"
      [matTooltip]="label.title"
      matTooltipPosition="above"
    ></ui-icon>
  }
</ng-template>

<ng-template #bestPriceLabel>
  <span class="best-price">
    <ui-icon [faName]="'badge-percent'" [faStyle]="'light'"></ui-icon> Bestpreis

    @if (product().prices?.validTo; as validTo) {
      bis <span class="highlighted-text">{{ validTo | luxonDate }}</span>
    }
  </span>
</ng-template>

<ng-template #discountPriceLabel>
  <span class="discount-price">
    Aktion »
    @if (prices()?.discountPercentage) {
      <span class="highlighted-text">{{ prices()?.discountPercentage }}%</span>
    }

    @if (product().prices?.validTo; as validTo) {
      sparen bis <span class="highlighted-text">{{ validTo | luxonDate }}</span>
    } @else {
      gespart
    }
  </span>
</ng-template>

<ng-template #promotionPriceLabel>
  <span class="discount-price">
    Aktion
    @if (product().prices?.validTo; as validTo) {
      » bis <span class="highlighted-text">{{ validTo | luxonDate }}</span>
    }
  </span>
</ng-template>
